import { render } from "./add-country-dialog.vue?vue&type=template&id=8d6c8f8c&ts=true"
import script from "./add-country-dialog.ts?vue&type=script&lang=ts"
export * from "./add-country-dialog.ts?vue&type=script&lang=ts"

import "../dialog.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__